import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { API_URL } from "../../constants/API_URL";
import { ParmakIziError } from "../../types/ErrorModals/ParmakIziError";
import { ParmakIziRequestModal } from "../../types/RequestModals/ParmakIziRequestModal";
import { ParmakIziResponseModal } from "../../types/modals";

export const getOgrenciParmakIzi = async (
  request: ParmakIziRequestModal
): Promise<ParmakIziResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<ParmakIziResponseModal[]>>(
      `${API_URL}/api/ParmakIzi/getOgrenciParmakIzi`,
      request
    );
    
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Parmak izi kaydı bulunamadı",
          correlationId: responseData?.correlationId,
        } as ParmakIziError;
      }
      
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as ParmakIziError;
      }
      
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as ParmakIziError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as ParmakIziError;
  }
};